<template>
  <div :class="$style.wrap">
    <div v-if="user">
      <label-box v-if="showId"
        color="gray"
        :label="[1, 2, 3, 11, 12].includes(user.account_type) ? user.customer_id : `ID: ${user.id}`"
        :size="type === 'inner' ? 'xs' : 'sm'"
        :class="labelClass" />
      <!-- ID・仮登録・リスク・受付/予約はすべて .wrap を基準にした絶対配置で、left / right の値でしか
           位置が決まらない。受付/予約だけ right アンカーにして、左端起点の既存 3 つと座標で干渉しない
           ようにしている（仮登録とリスクは同一クラス・同一座標なので既存どうしは重なる）。 -->
      <div
        v-if="pendingConsultationLabelVisible"
        :class="labelPendingClass"
        title="回答前のテキスト健康相談、または実施前のオンライン・バーチャル相談の予約があります">受付/予約</div>
      <div
        :class="`${ownUser.account_type >= 30
          ? 'unregistered_operator'
          : 'unregistered_teacher'}`"
        v-if="user.temporary && ownUser">仮登録</div>
      <div
        :class="`${ownUser.account_type >= 30
          ? 'unregistered_operator'
          : 'unregistered_teacher'}`"
        v-if="user.risk && user.risk.length && user.risk[user.risk.length - 1].type !== 11 && ownUser">{{ helper.master.labels.riskApplication.riskType[user.risk[user.risk.length - 1].type].label }}</div>
    </div>
    <basic-box
      :type="type" v-if="user"
      :bg="bg"
      :class="[isCancel ? $style.isCancel : '']">
      <div :class="className">
        <div :class="$style.user">
          <div :class="$style.thumb">
            <round-img width="60px" :src="getMyIconUrl(user)" />
          </div>
          <div :class="$style.user_text">
            <component
              :is="link ? 'router-link' : 'div'"
              :to="link ? link : ''"
              :class="$style.link"
              :target="targetWindow"
              @click="sendClick">
              <div :class="$style.info">
                <!-- kana / username は自由入力の氏名で HTML を埋める要件が無いため、
                     v-html でなく補間でエスケープして描画する。ただし検索画面
                     （UserList / Students / BulkEditWrapper / 事務局 RiskManagement）がヒット語を
                     <span class="highlight"> で括った値を渡してくるため、
                     そのスパンだけ要素として再構成しテキストは補間に通す -->
                <div :class="$style.kana"><span
                  v-for="(seg, i) in nameSegments(user.kana)"
                  :key="i"
                  :class="seg.highlight ? 'highlight' : null">{{ seg.text }}</span></div>
                <div :class="$style.name">
                  <div><span
                    v-for="(seg, i) in nameSegments(user.username)"
                    :key="i"
                    :class="seg.highlight ? 'highlight' : null">{{ seg.text }}</span></div>
                  <span v-if="user.age && showAge">（{{ user.age }}）</span>
                  <i v-if="user.gender" :class="user.gender === 1 ? $style.male : user.gender === 2 ? $style.female : $style.other" class="fa-solid fa-user" style="margin-left: 5px;" />
                  <div v-if="showMessageBtn && ownUser && ownUser.id" @click.prevent :class="$style.message" class="fa-solid fa-messages" @click="messageDetail">
                  </div>
                  <div v-if="showCocomoniBtn && ownUser && cocomoniData.img" @click.prevent :class="$style.cocomoni" @click="cocomoniDetail">
                    <img :class="$style.cocomoni_icon" :src="`/img/default/${cocomoniData.img}`" :alt="`${cocomoniData.alt}`">
                  </div>

                  <!-- ２週間アラートフラグ -->
                  <div
                     v-if="showWatchedUserFlag"
                    :class="$style.cursor_default"
                    @click.stop.prevent>
                    <i :class="$style.watchedUserIcon" class="fa-regular fa-flag-alt"></i>
                  </div>
                  <!-- 医師心理士メッセージ -->
                  <div
                     v-if="showCounselorMessage"
                    :class="$style.counselor_message"
                    @click.stop.prevent="clickCounselorMessage">
                    <i class="fa-regular fa-message-dots"></i>
                  </div>

                </div>
                <div :class="$style.belongs"
                  v-if="helper.master && helper.master.labels">
                  <span v-if="user.school && user.school.length" :class="$style.school">{{ user.school[0].name }}</span>

                  <!-- 医師心理士への共有メモ -->
                  <div
                    v-if="schoolMemo && schoolMemo.features"
                    class="n2br"
                    :class="$style.school_memo_wrap"
                    @click.stop.prevent>
                    <i :class="$style.school_memo_icon" class="fa-solid fa-comment-dots"></i>
                    <span :class="$style.baloon">{{ schoolMemo.features }}</span>
                  </div>

                  {{ isCompany ? helper.master.labels.users.company_account_type[user.account_type] : helper.master.labels.users.account_type[user.account_type] }}
                  <span v-if="user.school && !isCompany && user.account_type === 1 && user.school_year" :class="$style.school_year">{{ user.school_year }}年生</span>
                </div>
                <div v-if="user.count" :class="$style.count">
                  <div :class="$style.count_remaining">心理士{{ user.count.psychologist }}回/医師{{ user.count.doctor }}回</div>
                </div>
              </div>
            </component>
            <p v-if="showCancel" :class="$style.cancel">キャンセル</p>
            <p v-if="showCancelOnTheDay" :class="$style.cancel">当日キャンセル</p>
          </div>
        </div>
        <div>
          <slot name="btn"/>
        </div>
      </div>
      <slot name="main" />
    </basic-box>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LabelBox from './LabelBox.vue';
import BasicBox from './BasicBox';
import RoundImg from './RoundImg';
import cf from '@/mixins/commonFunctions.js';
import consultationLabel from '@/mixins/consultationLabel.js';
import { openPendingWindow, showInPendingWindow, closePendingWindow } from '@/lib/pendingWindow';

export default {
  name: 'UserBox',
  mixins: [cf, consultationLabel],
  components: {
    BasicBox,
    RoundImg,
    LabelBox,
  },
  props: {
    user: {
      type: Object,
    },
    ownUser: {
      type: Number,
    },
    targetBlank: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    time: {
      type: String,
    },
    type: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'inner'].includes(value),
    },
    showId: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    showCancelOnTheDay: {
      type: Boolean,
      default: false,
    },
    showCocomoniBtn: {
      type: Boolean,
      default: false,
    },
    showMessageBtn: {
      type: Boolean,
      default: false,
    },
    // 「受付/予約」ラベルを出す一覧だけが true を渡す（既定は非表示）
    showPendingConsultationLabel: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: null,
    },
    bg: {
      type: String,
      default: 'white',
      validator: (value) => ['white', 'gray', 'silver'].includes(value),
    },
    isCancel: {
      type: Boolean,
      default: false,
    },
    showAge: {
      type: Boolean,
      default: true,
    },
    saveTab: {
      type: String,
      default: null,
    },
    // isCompany: {
    //   type: Boolean,
    //   default: false,
    // },
    enableCounselorMessage: { // 医師心理士メッセージ機能を有効にするかどうか
      type: Boolean,
      default: false,
    },
    isMyCustomer: { // ログインユーザが医師心理士であり、かつ表示対象ユーザから見て自分が最終相談者かどうか
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFlag: false,
      reserves: null,
      schoolMemo: null,
      counselorMessages: [],
    };
  },
  computed: {
    ...mapState(['helper']),
    className() {
      const id = this.showId ? 'showId' : '';
      return `${this.$style.header} ${this.$style[this.type]} ${this.$style[id]}`;
    },
    labelClass() {
      const size = this.type === 'inner' ? 'xs' : 'sm';
      return `${this.$style.id} ${this.$style[size]}`;
    },
    targetWindow() {
      return this.targetBlank === true ? '_blank' : '';
    },
    cocomoniData() {
      let result = {};
      const userId = isNaN(this.user.id) ? this.user.rawId : this.user.id;
      if (this.user && this.ownUser && this.ownUser.cocomoni && this.ownUser.cocomoni[userId]) {
        if (this.ownUser.cocomoni[userId] >= 7) {
          result = {
            stenScore: this.ownUser.cocomoni[userId],
            text: 'High',
            img: 'arrow_up.png',
            alt: '上向き矢印',
          };
        } else if (this.ownUser.cocomoni[userId] < 7 && this.ownUser.cocomoni[userId] >= 3) {
          result = {
            stenScore: this.ownUser.cocomoni[userId],
            text: 'Middle',
            img: 'arrow_flat.png',
            alt: '横ばい矢印',
          };
        } else {
          result = {
            stenScore: this.ownUser.cocomoni[userId],
            text: 'Low',
            img: 'arrow_down.png',
            alt: '下向き矢印',
          };
        }
      }
      return result;
    },
    isCompany() {
      return Boolean(this.user && this.user.school && this.user.school.length && this.user.school[0].is_company);
    },
    showWatchedUserFlag() {
      // 医師心理士、事務局のアカウントタイプでない場合は処理を中断
      const allowedAccountTypes = [21, 22, 31]; // 医師心理士、事務局
      if (!this.ownUser || !allowedAccountTypes.includes(this.ownUser.account_type)) {
        return false;
      }
      // props.userにuserWatchデータがある場合はtrueを返す
      return this.user && this.user.userWatch && this.user.userWatch.is_watched;
    },
    pendingConsultationLabelVisible() {
      // 表示は prop 1 段で決める（ラベルを出す一覧だけが true を渡す）
      return this.showPendingConsultationLabel && this.hasPendingConsultation(this.user);
    },
    labelPendingClass() {
      return `${this.$style.pending_consultation_label} ${this.type === 'inner' ? this.$style.inner : ''}`;
    },
    showCounselorMessage() {
      if (!this.enableCounselorMessage) {
        return false;
      }
      if (!this.showWatchedUserFlag) {
        return false; // アラート旗が立たないユーザにはメッセージアイコン自体を表示しない
      }
      if (this.isMyCustomer) {
        return true; // 送信も可能
      }
      if (this.counselorMessages.length > 0) {
        return true; // 閲覧モード
      }
      return false;
    },
  },
  created() {
    this.getSchoolMemo();
    this.getCounselorMessages();
  },
  methods: {
    /**
     * 検索画面が注入する <span class="highlight">語</span> を分解し、
     * { highlight, text } のセグメント列にする（テンプレート側で補間描画するため、
     * ヒット語以外に HTML が含まれていてもテキストとしてエスケープされる）
     */
    nameSegments(value) {
      if (value === null || value === undefined) return [];
      // 氏名の印は区切り文字（改行を含む）をまたぐことがあるので、. でなく [\s\S] で改行も越えて切り出す
      return String(value)
        .split(/(<span class="highlight">[\s\S]*?<\/span>)/)
        .filter((part) => part !== '')
        .map((part) => {
          const matched = part.match(/^<span class="highlight">([\s\S]*?)<\/span>$/);
          return matched
            ? { highlight: true, text: matched[1] }
            : { highlight: false, text: part };
        });
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    sendClick() {
      this.$emit('clickedUser', {});

      if (this.saveTab) cf.saveTabState({ tab: this.saveTab });

    },

    cocomoniDetail() {
      const accountType = this.ownUser.account_type;
      let routeName = '';
      switch (accountType) {
        case 11:
        case 12:
          routeName = 'TeacherCocomoniDetail';
          break;
        case 21:
        case 22:
          routeName = 'CounselorCocomoniDetail';
          break;
        case 31:
          routeName = 'OperatorCocomoniDetail';
          break;
        case 3:
          routeName = 'CocomoniDetail';
          break;
        default:
          routeName = 'NotFound'; // ここへは基本割り振られないはず
          break;
      }
      // 印の中身は ID の一部だけのことがあるので、印を付ける前に退避した元の ID（rawId）を使う（cocomoniData と同じ）
      const userId = isNaN(this.user.id) ? this.user.rawId : this.user.id;
      const resolvedRoute = this.$router.resolve({
        name: routeName,
        params: { id: userId },
      });
      window.open(`${resolvedRoute.href}/`, '_blank');
    },

    async messageDetail() {
      // 応答を待ってから開くとブラウザにポップアップとして止められることがあるので、押した瞬間（最初の await より前）にタブを開いておく
      const messageWindow = openPendingWindow();
      this.showLoading();
      let targetUserId = this.user.id;

      // IDで検索した際にメッセージを送ろうとするとハイライトの影響でuser.idが正しく取れないので変換
      // 利用者IDが文字列かつspanタグがIDに含まれていれば本来のIDのみを抽出
      if (typeof this.user.id === 'string' && this.user.id.includes('</span>')) {
        targetUserId = Number(targetUserId.replace('<span class="highlight">', '').replace('</span>', ''));
      }

      // #3185 D（事務局起点）: 相手が学校管理者(11/12)なら学校共有ルーム(target_type=4)へ find-or-create。
      // school_id は対象管理者の所属校（WTT は単一校前提＝user.school[0]）。学生/医師心理士相手は従来の type=2 個人ルーム。
      // ※ account_type / school はハイライト汚染（user.id のみ）の影響を受けないため安全に参照できる。
      if ([11, 12].includes(this.user.account_type)
        && this.user.school && this.user.school.length && this.user.school[0].id) {
        const data = {
          flag: 11, // 事務局メッセージは作成時点で11(実施済み)
          user_id: this.ownUser.id, // backend 側で type=4 は user_id=事務局(1) に正規化される
          target_type: 4,
          school_id: this.user.school[0].id,
        };
        this.axios({
          method: 'POST',
          url: '/v1/messageGroup/set/register',
          data,
        })
          .then((response) => {
            const res = response.data;
            const resolvedRoute = this.$router.resolve({
              name: 'OperatorMessageDetail',
              params: { slug: res.group_id },
            });
            showInPendingWindow(messageWindow, resolvedRoute.href);
          })
          .catch((error) => {
            closePendingWindow(messageWindow);
            if (error.message) console.log(error.message);
            else console.log(error);
            alert('メッセージの初期化に失敗しました。');
          })
          .finally(() => {
            this.hideLoading();
          });
        return;
      }

      // storeから取得をやめ、吹き出しクリック時に存在するか確認
      let opeMessages;
      try {
        opeMessages = await this.axios({
          method: 'GET',
          url: '/v1/messagegroup/get/list',
          params: {
            target_user_id: targetUserId,
            target_type: 2,
            user_id: this.ownUser.id,
          },
        });
      } catch (error) {
        // 空のタブだけを残さない（エラーの扱いはこれまでどおり呼び出し元へ投げる）
        closePendingWindow(messageWindow);
        throw error;
      }

      const chatRoom = opeMessages.data.groups.data;

      if (!chatRoom.length) {
        // 事務局メッセージ未作成の場合は作成

        let id = this.user.id;

        // ハイライトされたIDの場合span タグが混ざるので削除
        if (typeof this.user.id === 'string') {
          const idStr = String(this.user.id);
          id = Number(idStr.replace(/[^0-9]/g, ''));
        }

        // メッセージ新規作成
        const data = {
          flag: 11, // 事務局メッセージは作成時点で11(実施済み)
          user_id: this.ownUser.id,
          target_type: 2, // 事務局個別メッセージ
          target_user_id: id,
        };

        this.axios({
          method: 'POST',
          url: '/v1/messageGroup/set/register',
          data,
        })
          .then((response) => {
            const res = response.data;
            const resolvedRoute = this.$router.resolve({
              name: 'OperatorMessageDetail',
              params: { slug: res.group_id },
            });
            showInPendingWindow(messageWindow, resolvedRoute.href);
          })
          .catch((error) => {
            closePendingWindow(messageWindow);
            if (error.message) console.log(error.message);
            else console.log(error);
            alert('メッセージの初期化に失敗しました。');
          })
          .finally(() => {
            this.hideLoading();
          });
      } else if (this.user && this.ownUser.id && chatRoom.length) {
        const targetGroup = chatRoom.find((room) => room.user_id === this.ownUser.id);
        if (!targetGroup) {
          // 事務局とのやりとりはあるが、
          // ログインユーザがチャットルーム作成ユーザと異なる場合
          closePendingWindow(messageWindow);
          alert('対象のメッセージを読み込めませんでした。\n再度お試しください。');
          this.hideLoading();
          return;
        }
        const resolvedRoute = this.$router.resolve({
          name: 'OperatorMessageDetail',
          params: { slug: targetGroup.id },
        });
        this.hideLoading();
        showInPendingWindow(messageWindow, resolvedRoute.href);
      } else {
        closePendingWindow(messageWindow);
      }
    },

    async getSchoolMemo() {
      // ログインユーザが医師心理士、事務局ではない場合は処理を中断
      const accountTypes = [21, 22, 31];
      if (!this.$store.state.user || !accountTypes.includes(this.$store.state.user.account_type)) {
        return;
      }
      // 表示対象者のデータに学校情報がない場合は処理を中断
      if (!this.user || !this.user.school || !this.user.school.length || !this.user.school[0].id) {
        return;
      }
      // 学校メモのデータを取得
      const params = { school_id: this.user.school[0].id };
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/schoolMemo/get/detail',
          params,
        });
        this.schoolMemo = response.data.detail.data.length ? response.data.detail.data[0] : null;
      } catch (error) {
        console.error('Failed to fetch school memo:', error);
      }
    },

    async getCounselorMessages() {
      // 取得の必要がない場合は処理を中断
      if (!this.showWatchedUserFlag) {
        return; // 医師心理士、事務局以外は取得しない。また、アラート旗が立たないユーザにはメッセージ自体を表示しない
      }
      if (this.isMyCustomer) {
        return; // 自分の顧客の場合、メッセージアイコンは無条件で表示するが、既存メッセージを取得する必要はない
      }

      let targetUserId = this.user.id;

      // IDで検索した際にメッセージを取得しようとするとハイライトの影響でuser.idが正しく取れないので変換
      // 利用者IDが文字列かつspanタグがIDに含まれていれば本来のIDのみを抽出
      if (typeof this.user.id === 'string' && this.user.id.includes('</span>')) {
        targetUserId = Number(targetUserId.replace('<span class="highlight">', '').replace('</span>', ''));
      }

      // 取得処理
      const params = {
        // user_id: this.user.id,
        target_user_id: targetUserId,
        target_type: 3, // 医師心理士から相談者へのメッセージ
        isMessages: 1,
        limit: 99999, // 全件取得
        page: 1,
      };
      try {
        const res = await this.axios({
          method: 'GET',
          url: '/v1/messagegroup/get/listOrderByNewest', // 新着順で取得する
          params,
        });
        this.counselorMessages = res.data.groups ? res.data.groups.data : [];
      } catch (error) {
        console.error(error);
        alert('メッセージの取得に失敗しました');
      }
    },

    clickCounselorMessage() {
      const stateUser = this.$store.state.user; // state のユーザ

      // コンポーネント名を決定
      let componentName;
      if (stateUser.account_type === 31) {
        componentName = 'OperatorCounselorMessages';
      } else if ([21, 22].includes(stateUser.account_type)) {
        componentName = 'CounselorCounselorMessages';
      } else {
        componentName = 'UserCounselorMessages';
      }

      let targetUserId = this.user.id;

      // IDで検索した際にメッセージ画面へ遷移する際、ハイライトの影響でuser.idが正しく取れないので変換
      // 利用者IDが文字列かつspanタグがIDに含まれていれば本来のIDのみを抽出
      if (typeof this.user.id === 'string' && this.user.id.includes('</span>')) {
        targetUserId = Number(targetUserId.replace('<span class="highlight">', '').replace('</span>', ''));
      }

      const resolvedRoute = this.$router.resolve({
        name: componentName,
        params: { slug: targetUserId },
      });
      window.open(resolvedRoute.href, '_blank');
    },
  },
};
</script>

<style lang="scss" module>
.header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @include sm-view {
    display: block;
  }
  &.showId {
    padding-top: 40px;
    &.inner {
      padding-top: 30px;
    }
  }
}
.wrap {
  position: relative;
}
.id {
  position: absolute;
  z-index: 1;

  &.sm {
    margin: 16px 0 0 -6px;
    width: 120px;
  }
  &.xs {
    margin: 14px 0 0 -4px;
    width: 100px;
  }
}
// 「受付/予約」ラベル。既存の 3 ラベル（ID・仮登録・リスク）は全て左端起点なので、
// 右端起点にして既存の座標指定を 1 行も触らずに衝突を避ける。
// 見た目は「NEW」表示（ContentsBox / RiskApplicationBox の .boxTag.new）と同じ表現に揃える:
// ピンク塗り・白の太字・角丸 4px。仮登録・リスクは「赤枠・白地・赤字・角丸 20px」なので、
// 塗り／枠と角丸の両方で区別がつく（同じ赤枠白地で並べると仮登録と見分けにくい、という
// 手動確認の指摘を受けた形）。NEW は利用者一覧（管理サイト・事務局）には出ないので、同じ
// 画面で「NEW」と並んで意味が混線することはない。位置指定（top / right）は NEW からは
// 取らない — NEW の -10px / -8px はカード枠からはみ出す配置で、一覧カードの ID 行と
// 同じ段に置く本ラベルには合わない。
.pending_consultation_label {
  position: absolute;
  top: 15px;
  right: 0;
  z-index: 1;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  white-space: nowrap;

  &.inner {
    top: 9px;
  }

  // 狭幅では本ラベルだけを縮める（値は NEW の sm-view と同じ）。
  // 仮登録・リスクは左端起点（left: 100px / 130px）で、幅が文言の長さで決まる。
  // 最長は「ミドルリスク」で 120px（表示されうるのは他に「ハイリスク」だけ）。
  // 2026-09-08 実測: 事務局 360px ではカード幅 288px に対しリスクラベルの右端が 220px
  // ＝右端起点の本ラベルに残る幅は 68px しかない。この指定での実測幅は 62.3px
  // （2026-09-13・360/375/390px とも・管理サイト／事務局の 3 ラベル同時状態で重なり 0）。
  // 既存 3 ラベルの宣言は 1 行も触らない方針なので、縮めるのは本ラベル側だけにする。
  @include sm-view {
    padding: 3px 7px 2px;
    font-size: 11px;
  }
}

.user {
  display: flex;
  align-items: center;
  @include sm-view {
    display: block;
  }
  &_text {
    display: flex;
    align-items: center;
  }
}

.thumb {
  display: block;
  margin-right: calc(var(--spacer-base) * 2);
  width: 50px;
  @include sm-view {
    margin-bottom: 5px;
  }
}

.info {
  display: block;
}

.count {
  &_remaining {
    font-size: 11px;
    @include md-view {
      font-size: 10px;
    }
  }
}

.history {
  position: relative;
  top: 3px;
  left: 65px;
  &_flex {
    display: flex;
  }
}
.icon {
  position: relative;
  z-index: 1;
  margin: 2px 0 0 2px;
}

.table_flex {
  width: 70%;
  table-layout: fixed;
}

.kana {
  font-size: 10px;
}

.name {
  font-size: 20px;
  line-height: 1.2;
  display: flex;

  @include md-view {
    font-size: 17px;
  }
}
.male {
  color: var(--blue-main);
}
.female {
  color: var(--pink);
}
.other {
  // 性別「その他」 - イエローオレンジ (男女アイコンと同程度の彩度・明度 2026-05-25 定例決定)
  color: #f0be1c;
}

.time {
  font-size: 12px;

  @include md-view {
    font-size: 11px;
  }
}

.belongs {
  font-size: 12px;
  @include md-view {
    font-size: 11px;
  }
}
.icon {
  display: block;
}

// 医師心理士への共有メモ
.school_memo_wrap {
  position: relative;
  display: inline-block;
  &:hover .baloon,
  .baloon:hover {
    display: block;
  }

  .school_memo_icon {
    color: var(--gray-side);
    margin-right: 5px;
    font-size: 1.2rem;
    position: relative;
    cursor: pointer;
  }
  .baloon {
    font-size: .8rem;
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    background: #fff;
    border: 1px solid var(--gray-side);
    border-radius: 6px;
    padding: 4px 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    pointer-events: auto;
    max-width: 820px;
    min-width: 480px;
    @include md-view {
      max-width: 600px;
      min-width: 320px;
    }
    width: auto;
    word-break: break-word;
    white-space: pre-line;
  }
  .baloon::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 8px 10px 8px;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
    display: block;
    width: 0;
  }
}

.inner {
  .name {
    font-size: 16px;
  }
  .belongs, .time {
    font-size: 10px;
  }
}

.school {
  margin-right: 8px;
  &_year {
    margin-left: 8px;
  }
}

.cancel {
  font-size: 12px;
  color: var(--pink);
  margin-left: 12px;
}

.link {
  display: block;
  color: var(--black);
}
.message {
  margin-left: 5px;
  color: var(--gray-side);
  cursor: pointer;
}
.watchedUserIcon {
  margin-left: 5px;
  color: red;
}
.counselor_message {
  margin-left: 5px;
  cursor: pointer;
}
.cocomoni {
  margin-left: 5px;
  color: var(--gray-side);
  cursor: pointer;

  &_icon {
    width: 24px;
  }
}
.isCancel {
  box-shadow: none;
}

.cursor_default {
  cursor: default !important;
}
</style>
<style lang="scss" scoped>
:deep(.highlight) {
  background: linear-gradient(transparent 0%, #FFFF00 0%);
}

.unregistered {
  &_operator {
    position: absolute;
    top: 9px;
    left: 100px;
    padding: 3px 15px;
    z-index: 1;
    border: red solid;
    color: red;
    background-color: white;
    border-radius: 20px;
    font-size: 14px;
  }
  &_teacher {
    position: absolute;
    top: 15px;
    left: 130px;
    padding: 3px 15px;
    z-index: 1;
    border: 1px red solid;
    color: red;
    background-color: white;
    border-radius: 20px;
    font-size: 14px;
  }
}
</style>
